import { useTranslation } from 'react-i18next';

import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';

import * as styles from '../basic-article-hero/styles/basicArticleHero.module.scss';

import type { TPostLayout } from '../../types';

const initializer = {
  nodes: [],
};

export const TaxonomySubhead = ({
  className,
  customers = initializer,
  industries = initializer,
  platforms = initializer,
}: {
  className?: string;
  customers: TPostLayout['customers'];
  industries: TPostLayout['industries'];
  platforms: TPostLayout['platforms'];
}) => {
  const { t } = useTranslation();

  const customer = customers?.nodes?.[0]?.name || '';
  const industry = industries?.nodes[0]?.name || '';
  const platform = platforms?.nodes[0]?.name || '';
  const hasCaseStudyTaxonomy = Boolean(customer || industry || platform);

  if (!hasCaseStudyTaxonomy) return null;

  return (
    <div className={generateClassName([className, styles.basicLayout, styles.subhead])}>
      {customer && (
        <span>
          <strong>{`${t('templates_caseStudy_customer')}`}: </strong>
          {customer}
        </span>
      )}
      {industry && (
        <span>
          <strong>{`${t('templates_caseStudy_industry')}`}: </strong>
          {industry}
        </span>
      )}
      {platform && (
        <span>
          <strong>{`${t('templates_caseStudy_platform')}`}: </strong>
          {platform}
        </span>
      )}
    </div>
  );
};
